import { Injectable, Injector } from '@angular/core';
import { ParameterResult } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';
import { Observable } from 'rxjs';

export interface AlarmTypeParams extends DefaultHttpHeaders {
  /** Unique identifier of alarm type */
  alarmTypeCode: string;
}

@Injectable()
export class AlarmTypeService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Service for obtaining alarm type by code
   * Service for obtaining alarm type by code
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Catalog/getComeroundAlarmTypeById
   */
  alarmType(params: AlarmTypeParams): Observable<ParameterResult> {
    const pathParams = {
      alarmTypeCode: params.alarmTypeCode,
    };
    return this.get<ParameterResult>({
      suffix: `/comeround/catalog/alarmType/${pathParams.alarmTypeCode}`,
    });
  }
}
